/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { Component } from "react"
import PropTypes from "prop-types"
import NavBar from "./navbar/Navbar"
import "./layout.css"
import styled from "@emotion/styled"
import {  TiSocialLinkedinCircular, TiSocialGithubCircular } from 'react-icons/ti';
import { IconContext } from "react-icons";

const MainContent = styled.main`
  max-width: 1200px;
  margin: 150px auto 100px auto;

  @media (max-width: 1200px) {
    max-width: 900px;
    margin-top: 125px;
    margin-bottom: 9rem;
  }

  @media (max-width: 768px) {
    max-width: 700px;
    margin-top: 6.25rem;
  }

  @media (max-width: 425px) {
    max-width: 350px;
    margin-top: 4.5rem;
  }

  @media (max-width: 360px) {
    max-width: 300px;
    margin-top: 3.75rem;
  }

  @media (max-width: 320px) {
    max-width: 290px;
  }
`

const FooterContent = styled.footer`
  width: 90%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin-left: auto;
  margin-right: auto;
  border-top: 1px solid #000000FF;
  padding-top: 2rem;
  margin: 1rem auto;
  text-align: center;
  clear: both;

  @media (max-width: 1200px) {
    max-width: 900px;
  }

  @media (max-width: 768px) {
    max-width: 700px;
  }

  @media (max-width: 425px) {
    max-width: 350px;
  }

  @media (max-width: 320px) {
    max-width: 290px;
  }
`

const SocialMediaContainer = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 1rem; 
`

class Layout extends Component {

  constructor(props) {
    super(props);
    this.state = { navbarOpen: false };
  }

  handleNavbar = () => {
    this.setState({ navbarOpen: !this.state.navbarOpen });
  }

  render() {
    const { children } = this.props;
    return (
      <div>
        <NavBar
          navbarState={this.state.navbarOpen} 
          handleNavbar={this.handleNavbar}
        />
        <MainContent>{children}</MainContent>
        <FooterContent>
          <IconContext.Provider value={{ className: "social-icons" }}>
            <SocialMediaContainer>
              <a href="https://github.com/axthomas29" target="_blank" rel="noopener noreferrer">
                <TiSocialGithubCircular />
              </a>
              <a href="https://www.linkedin.com/in/alexandra-c-thomas/" target="_blank" rel="noopener noreferrer">
                <TiSocialLinkedinCircular />
              </a>
            </SocialMediaContainer>
          </IconContext.Provider>
          © {new Date().getFullYear()} | Alexandra Thomas
        </FooterContent>
      </div>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout